import { useQuery } from '@apollo/client';
import { CircularProgress, Stack } from '@mui/material';
import { PageTitle, useCustomSnackbar } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { RuleStatusChip } from '../RuleStatusChip/RuleStatusChip';
import { I18nNamespace } from '~/common/types';

import { GET_RULE_HEADER } from './Rule.query.gql';

interface RuleDetailPageTitleProps {
  id?: string;
}

export const RuleDetailPageTitle = ({ id }: RuleDetailPageTitleProps) => {
  const { t } = useTranslation(I18nNamespace.ruleBuilder);

  const { onError } = useCustomSnackbar();
  const { data, loading } = useQuery(GET_RULE_HEADER, { variables: { id }, skip: !id, onError });

  const { title, status } = useMemo(
    () => ({
      title: data?.tesseract.rule.name,
      // using helper to set internal enum but consider undefined for omitting status chip entirely
      status: data?.tesseract.rule.status,
    }),
    [data],
  );

  return !loading ? (
    <>
      <Helmet>
        <title>{title ?? t('DetailPage.fallbackTitle')}</title>
      </Helmet>
      <PageTitle
        title={
          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: 4,
            }}
          >
            {title}
            <RuleStatusChip status={status} />
          </Stack>
        }
      ></PageTitle>
    </>
  ) : (
    <CircularProgress size={28} />
  );
};
